import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import FormEdit from './Form';
import { SubmissionError } from 'redux-form';
import {toast} from 'react-toastify';

class EditPopup extends Component {

    constructor(props) {

        super(props);
        this.state = {
            open: false,
            data : {},
            index : null,
            loaded : true
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

    }


    handleOpen(index, data) {

        if(data) {

            this.setState({loaded : true, data, open: true, index});

        }

    }

    handleClose() {

        this.setState({open: false, data : {}, index : null});

    }

    onSubmit(data) {

        this.props.onChildrenChange(data.childrens, this.state.index);
        this.handleClose();


    }


    render() {

        const {className} = this.props;
        const {loaded} = this.state;

        return (

            <Modal isOpen={this.state.open} size={'lg'} className={className} fade={false}>

                <ModalHeader toggle={() => this.handleClose()}>Editer</ModalHeader>

                {!loaded && <Loading />}
                {loaded && <FormEdit onSubmit={this.onSubmit} initialValues={this.state.data} />}

            </Modal>

        );


    }
}

export default EditPopup



// WEBPACK FOOTER //
// ./src/components/Form/popup/PopupEditCollection.js